module.exports = __webpack_public_path__ + "img/boat-6.0f11e6db.jpg";